import { FileImageOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import Dragger from "antd/lib/upload/Dragger";
import { isString } from "lodash";
import React, { Fragment, useCallback } from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  submit: (values: any) => void;
  data: any;
};

export const ColorGroupForm: React.FC<FormType> = (props) => {
  const { form, values, data, submit } = props;
  const {
    variantColors: { nodes: variantColors },
  } = data;

  const onFinish = (values: any) => {
    const input = {
      ...values,
      patch: values.patch?.file,
      colorColorGroups: values.colorColorGroups?.map((colorId: any) => ({
        colorId,
      })),
    };
    submit(input);
  };

  const uploadProps = {
    maxCount: 1,
    accept: "image/*",
    listType: "picture-card",
    beforeUpload: () => {
      return false;
    },
  };

  const onValuesChange = useCallback(
    (changedValues) => {
      const fieldValues: any[] = [];
      if (changedValues.patch && changedValues.patch.file.status === "removed") {
        fieldValues.push({ name: ["patch"], value: null });
      }
      form.setFields(fieldValues);
    },
    [form],
  );

  return (
    <Form layout="vertical" form={form} initialValues={values} onValuesChange={onValuesChange} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="nameIt" label="Name IT" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameEn" label="Name EN" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="patch" label="Patch">
            <Dragger {...uploadProps} defaultFileList={values?.patch}>
              <div>
                <FileImageOutlined style={{ fontSize: "30px" }} />
                <div style={{ marginTop: 8 }}>Click or drop here</div>
              </div>
            </Dragger>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="colorColorGroups" label="Colors">
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionLabelProp="label"
              filterOption={(input, option) => {
                let label = "";
                if (option?.label && isString(option.label)) label = option.label;
                let value = option?.value;
                return (
                  label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
            >
              {variantColors.map((color: any) => (
                <Select.Option
                  key={color.id}
                  value={color.id}
                  label={
                    <Fragment>
                      <b>{color.code}</b> - {color.nameIt}
                    </Fragment>
                  }
                >
                  <b>{color.code}</b> - {color.nameIt}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
